var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTotalReporting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 23,
    height: 23,
    rx: 3.5,
    stroke: "#111928"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8388_44898)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.856 15.6429L12.2 17.4886V19.6905H6.6C5.712 19.6905 5 18.97 5 18.0714V5.11905C5 4.68965 5.16857 4.27784 5.46863 3.97421C5.76869 3.67058 6.17565 3.5 6.6 3.5H7.4V9.16667L9.4 7.95238L11.4 9.16667V3.5H16.2C16.6243 3.5 17.0313 3.67058 17.3314 3.97421C17.6314 4.27784 17.8 4.68965 17.8 5.11905V12.0324L16.6 11.3686L8.856 15.6429ZM21 15.6429L16.6 13.2143L12.2 15.6429L16.6 18.0714L21 15.6429ZM13.8 17.3348V18.9538L16.6 20.5L19.4 18.9538V17.3348L16.6 18.881L13.8 17.3348Z",
    fill: "#111928"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8388_44898"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.2,
    height: 15.2,
    fill: "white",
    transform: "translate(4 4.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalReporting);
export default __webpack_public_path__ + "static/media/total-reporting.6189b6982b97231bc7daec61fc6f7c52.svg";
export { ForwardRef as ReactComponent };